const actions = {
  SET_STATE: 'role/SET_STATE',
  REFRESH_ERRORS: 'role/REFRESH_ERRORS',
  ALL: 'role/ALL',
  FETCH_ALL: 'role/FETCH_ALL',
  DETAILS: 'role/DETAILS',
  ADD: 'role/ADD',
  EDIT: 'role/EDIT',
  REMOVE: 'role/REMOVE'
};

export default actions
